<template>
  <label
    :for="props.for"
    class="mb-1 block text-left text-sm font-medium text-background-fg/70"
  >
    <slot />
  </label>
</template>

<script setup lang="ts">
const props = defineProps<{
  for?: string
}>()
</script>
